var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportCard',{attrs:{"report":_vm.report,"index":_vm.index,"filters":_vm.filters,"loading":_vm.loading},on:{"dashboardReportSetDisplay":(data) => _vm.$emit('dashboardReportSetDisplay', data),"refresh":function($event){return _vm.$emit('refresh')}}},[_c('Box',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }